import { ManagePracticeService } from 'src/app/manage-practice/manage-practice.service';
import { SettingsService } from './../../settings/settings.service';

import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomLoadingService } from '../custom-loading/custom-loading.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
export interface DialogData {
  animal: string;
  name: string;
}
@Component({
  selector: 'app-mailing-dialog',
  templateUrl: './mailing-dialog.component.html',
  styleUrls: ['./mailing-dialog.component.css']
})
export class MailingDialogComponent implements OnInit {
  mailingAddress1: any = ""
  mailingAddress2: any = ""
  state: any = ""
  city: any = ""
  contact: any = ""
  fax: any = ""
  zipcode: any = ""
  submit: any = ""
  title: any = ""
  constructor(private router:Router,
     private settingsService: SettingsService, 
     private loadingService: CustomLoadingService,
   private  managePracticeService:ManagePracticeService,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<MailingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataObject: any) { }
  ngOnInit(): void {
    this.loadingService.show()
    this.managePracticeService.getProviderAddress(1).subscribe(res => {
      this.dataObject = res;
      this.loadingService.hide()
    }, () => { }, () => { this.loadingService.hide() })

    this.mailingAddress1 = this.translate.instant("MailingAddress.MailingAddressLine1.Label")
    this.mailingAddress2 = this.translate.instant("MailingAddress.MailingAddressLine2.Label")
    this.state = this.translate.instant("MailingAddress.State.Label")
    this.city = this.translate.instant("MailingAddress.City.Label")
    this.contact = this.translate.instant("MailingAddress.Contact.Label")
    this.fax = this.translate.instant("MailingAddress.Fax.Label")
    this.zipcode = this.translate.instant("MailingAddress.Zipcode.Label")
    this.submit = this.translate.instant("Common.Edit")
    this.title = this.translate.instant("MailingAddress.DialogTitle")

    this.translate.onLangChange.subscribe(res => {
      this.mailingAddress1 = this.translate.instant("MailingAddress.MailingAddressLine1.Label")
      this.mailingAddress2 = this.translate.instant("MailingAddress.MailingAddressLine2.Label")
      this.state = this.translate.instant("MailingAddress.State.Label")
      this.city = this.translate.instant("MailingAddress.City.Label")
      this.contact = this.translate.instant("MailingAddress.Contact.Label")
      this.fax = this.translate.instant("MailingAddress.Fax.Label")
      this.zipcode = this.translate.instant("MailingAddress.Zipcode.Label")
      this.submit = this.translate.instant("Common.Submit")
      this.title = this.translate.instant("MailingAddress.DialogTitle")
    })

  }

  onNoClick(): void {
    this.closeDialog();
    this.router.navigate(["/managepractice/locations/mailingaddress"])

  }
 closeDialog(): void{
  this.dialogRef.close();

 }

}
